import { fetchApi } from "./api";
import { API_ENDPOINTS } from "../config/api";
import type {
  FeaturedProduct,
  FeaturedProductCreate,
  FeaturedProductUpdate,
  ReorderItem,
} from "@/types/products";

export interface ListFeaturedOptions {
  context?: string;
  active_only?: boolean;
  limit?: number;
  offset?: number;
}

/** List featured products with optional context filter. */
export async function listFeatured(
  opts: ListFeaturedOptions = {},
): Promise<FeaturedProduct[]> {
  const params = new URLSearchParams();
  if (opts.context) params.set("context", opts.context);
  if (opts.active_only) params.set("active_only", "true");
  if (opts.limit != null) params.set("limit", String(opts.limit));
  if (opts.offset != null) params.set("offset", String(opts.offset));
  const qs = params.toString();
  return fetchApi<FeaturedProduct[]>(
    `${API_ENDPOINTS.featuredProducts}${qs ? `?${qs}` : ""}`,
  );
}

/** Create a new featured product entry. */
export async function createFeatured(
  data: FeaturedProductCreate,
): Promise<FeaturedProduct> {
  return fetchApi<FeaturedProduct>(API_ENDPOINTS.featuredProducts, {
    method: "POST",
    body: JSON.stringify(data),
  });
}

/** Update an existing featured product entry. */
export async function updateFeatured(
  id: number,
  patch: FeaturedProductUpdate,
): Promise<FeaturedProduct> {
  return fetchApi<FeaturedProduct>(API_ENDPOINTS.featuredProduct(id), {
    method: "PUT",
    body: JSON.stringify(patch),
  });
}

/** Delete a featured product entry. */
export async function deleteFeatured(id: number): Promise<void> {
  return fetchApi<void>(API_ENDPOINTS.featuredProduct(id), {
    method: "DELETE",
  });
}

/** Bulk reorder featured products. */
export async function reorderFeatured(items: ReorderItem[]): Promise<void> {
  return fetchApi<void>(API_ENDPOINTS.featuredProductsReorder, {
    method: "POST",
    body: JSON.stringify(items),
  });
}
